import React, { Ref, forwardRef, useImperativeHandle, useRef } from 'react';
import { FieldPropsExt } from '../../components';
import { TextField } from '../text';
import { isEmailValid } from './EmailFunctions';

export interface EmailFieldProps extends FieldPropsExt {
  value: string | null;
  validate?: boolean;
  onChange: (value: string) => void;
}

const EmailFieldComponent: React.ForwardRefRenderFunction<
  HTMLInputElement | null,
  EmailFieldProps
> = (props: EmailFieldProps, ref: Ref<HTMLInputElement | null>) => {
  const { validate = false } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => inputRef?.current);

  const validationMethod = (value: string): string => {
    if (!isEmailValid(value, props.required ?? false)) {
      return 'Please enter a valid email address';
    }

    return '';
  };

  return (
    <TextField
      {...props}
      ref={inputRef}
      placeholder="name@email.com"
      value={props.value ?? ''}
      validate={validate}
      onChange={props.onChange}
      validationMethod={validationMethod}
    />
  );
};

const EmailField = forwardRef(EmailFieldComponent);

export default EmailField;
